import React, { Suspense, lazy, useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { FallbackView } from '../../_metronic/partials';
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper';
import { MenuTestPage } from '../pages/MenuTestPage';
import { BookingTable } from '../pages/BookForm/BookingTable';
import ShipmentForm from '../pages/Shipment/ShipmentForm';
import ShipmentPopup from '../pages/Shipment/ShipmentPopup';
import BookingPrint from '../pages/BookForm/BookingPrint';
import HubPoint from '../pages/Hub/HubPoint';
import { ShipmentDrop } from '../pages/Shipment/ShipmentDrop';
import 'react-datepicker/dist/react-datepicker.css';
import { BookingDrop } from '../pages/BookForm/BookingDrop';
import { CustomerDrop } from '../pages/Customer/CustomerDrop';
import { CustomerTable } from '../pages/Customer/CustomerTable';
import ExpensesForm from '../pages/Expenses/ExpensesForm';
import OutstandingReport from '../pages/Reports/OutstandingReport';
import JobReport from '../pages/Reports/JobReport';
import ReportsPage from '../pages/Reports/ReportsPage';
import { Profile } from '../pages/Profile/Profile';





export function PrivateRoutes() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/shipmentform') {
      localStorage.setItem('shipmentChecked', 'true');
    } else {
      localStorage.setItem('shipmentChecked', 'false');
    }
  }, [location.pathname]);

  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'));
  const CustomerPageWrapper = lazy(() => import('../pages/Customer/Customerwrapper'));
  const Sucesswrapper = lazy(() => import('../pages/SucessPage/Sucesswrapper'));
  const Failurewrapper = lazy(() => import('../pages/FailurePage/Failurewrapper'));
  const Adduserwrapper = lazy(() => import('../pages/AddUser/Adduserwrapper'));
  const ReportsPageviewwrapper = lazy(() => import('../pages/Reports/ReportsPageviewwrapper'));
  const Bookingwrapper = lazy(() => import('../pages/BookForm/Bookingwrapper'));
  const Expenseswrapper = lazy(() => import('../pages/Expenses/Expenseswrapper'));
  const Hubwrapper = lazy(() => import('../pages/Hub/Hubwrapper'));
  const Shipmentwrapper = lazy(() => import('../pages/Shipment/Shipmentwrapper'));
  const UserTableviewwrapper = lazy(() => import('../pages/Addusertableview/UserTableviewwrapper'));
  const PendingPaymentwrapper = lazy(() => import('../pages/PendingPayment/PendingPaymentwrapper'));
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'));
  const DailyReport = lazy(() => import('../pages/Reports/DailReport'));
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'));
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'));
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'));
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'));

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/dashboard' component={DashboardWrapper} />

        {/* Expenses Routes */}
        <Route path='/expenses' exact component={Expenseswrapper} />
        <Route path='/expenses/expensesform' component={ExpensesForm} />

        {/* User Routes */}
        <Route path='/user' exact component={UserTableviewwrapper} />
        <Route path='/user/adduser' component={Adduserwrapper} />

        {/* Customer Routes */}
        <Route path='/customerTable' exact component={CustomerTable} />
        <Route path='/customerTable/customerform' component={CustomerPageWrapper} />

        {/* Booking Routes */}
        <Route path='/bookingtable' exact component={BookingTable} />
        <Route path='/bookingtable/bookingform' component={Bookingwrapper} />

        {/* Hub Routes */}
        <Route path='/hubtable' exact component={Hubwrapper} />
        <Route path='/hubtable/hubform' component={HubPoint} />

        {/* Shipment Routes (Now structured properly) */}
        <Route path='/shipment' exact component={Shipmentwrapper} />
        <Route path='/shipment/shipmentform' component={ShipmentForm} />

        {/* Other Routes */}
        <Route path='/shipmentdrop' component={ShipmentDrop} />
        <Route path='/shipmentPopup' component={ShipmentPopup} />
        <Route path='/bookingprint' component={BookingPrint} />
        <Route path='/sucess' component={Sucesswrapper} />
        <Route path='/failure' component={Failurewrapper} />
        {/* <Route path='/monthlyreports' component={ReportsPageviewwrapper} />
      <Route path='/dailyreports' component={DailyReport} /> */}
        {/* <Route path='/outstandingreports' component={OutstandingReport} />
      <Route path='/jobreport' component={JobReport} /> */}
        <Route path='/pendingpayment' component={PendingPaymentwrapper} />
        <Route path='/bookingdrop' component={BookingDrop} />
        <Route path='/customerdrop' component={CustomerDrop} />
        <Route path='/profilepage' component={Profile} />
        <Route path='/builder' component={BuilderPageWrapper} />

        {/* Crafted Pages */}
        <Route path='/crafted/pages/profile' component={ProfilePage} />
        <Route path='/crafted/pages/wizards' component={WizardsPage} />
        <Route path='/crafted/widgets' component={WidgetsPage} />
        <Route path='/reports' component={ReportsPage} />
        <Route path='/crafted/account' component={AccountPage} />

        {/* Apps */}
        <Route path='/apps/chat' component={ChatPage} />
        <Route path='/menu-test' component={MenuTestPage} />

        {/* Redirects */}
        <Redirect from='/auth' to='/dashboard' />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  );
}